<template>
  <div class="timeline-container" :class="{ 'centered-view': props.readOnly }">
    <table
      class="schedule-table"
      :class="{ 'single-week-table': props.readOnly }"
    >
      <thead>
        <tr>
          <th class="fixed-column slots-header"></th>
          <th
            v-for="(weekInfo, index) in weekHeaders"
            :key="'week-' + index"
            :colspan="7"
            class="week-header text-center"
          >
            Semana {{ weekInfo.weekNumber }} <span>{{ weekInfo.month }}</span>
            {{ weekInfo.year }}
            <span
              v-if="weekInfo.weekNumber == 1 && weekInfo.month == 'Diciembre'"
              >- Enero {{ weekInfo.year + 1 }}</span
            >
          </th>
        </tr>
        <tr>
          <th class="fixed-column slots-header"></th>
          <th
            v-for="day in days"
            :key="day.toString()"
            class="day-header text-center"
            v-html="formatDayHeader(day)"
          ></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(slot, index) in timeSlots" :key="slot.id">
          <tr>
            <td
              class="fixed-column slots-column"
              :style="{
                backgroundColor: slot.color
              }"
            >
              {{ slot.name }}
            </td>
            <!-- :class="{ 'bg-grey-lighten-4': hover }" -->
            <td
              v-for="day in days"
              :key="day.toString()"
              class="time-slot cursor-pointer"
              :style="{
                backgroundColor: slot.color,
                borderTop:
                  (index >= 5 && props.puestoId == 1) ||
                  (index >= 16 && props.puestoId == 2)
                    ? '0px solid black'
                    : 'none',
                borderBottomColor:
                  (index >= 5 && props.puestoId == 1) ||
                  (index >= 16 && props.puestoId == 2)
                    ? 'black'
                    : 'white'
              }"
              @click="$emit('slotClick', { day, slotId: slot.id })"
              @mouseenter="hover = true"
              @mouseleave="hover = false"
            >
              <div class="d-flex flex-wrap gap-1 slot-content">
                <template v-if="getAssignments(day, slot.id).length > 0">
                  <v-chip
                    v-for="user in getAssignments(day, slot.id)"
                    :key="user.id"
                    :style="{
                      backgroundColor: getColorUser(user.id),
                      color: isColorDark(getColorUser(user.id))
                        ? 'white'
                        : 'black',
                      border: user.prevision ? '4px solid red' : 'none'
                    }"
                    size="x-small"
                    variant="elevated"
                    class="cursor-pointer"
                    density="compact"
                    @click.stop="
                      $emit('chipClick', { day, slotId: slot.id, user })
                    "
                  >
                    {{ user.iniciales }}
                  </v-chip>
                </template>
              </div>
            </td>
          </tr>
          <!-- v-if="isTurnoTarde(slot) && index < timeSlots.length -   1" -->

          <tr
            v-if="
              (index > 5 && props.puestoId == 1) ||
              (index > 16 && props.puestoId == 2)
            "
            class="separator-row-1"
          >
            <td class="fixed-column separator-cell-1"></td>
            <td
              v-for="day in days"
              :key="'sep-' + day.toString()"
              class="separator-cell-1"
            ></td>
          </tr>
          <tr
            v-if="
              (index == 3 && props.puestoId == 1) ||
              (index == 7 && props.puestoId == 2)
            "
            class="separator-row-3"
          >
            <td
              class="fixed-column"
              style="height: 2px; background-color: black"
            ></td>
            <td
              v-for="day in days"
              :key="'sep-' + day.toString()"
              class="separator-cell-3"
            ></td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useTurnosStore } from '@/stores/turnosStore'
import { isColorDark } from '@/utils/helpers'

const turnosStore = useTurnosStore()
const { months } = turnosStore // Desestructuramos months del store

const props = defineProps({
  weekOffset: {
    type: Number,
    required: true
  },
  selectedYear: {
    type: Number,
    required: true
  },
  timeSlots: {
    type: Array,
    required: true
  },
  schedules: {
    type: Object,
    required: true
  },
  users: {
    type: Array,
    required: true
  },
  readOnly: {
    type: Boolean,
    default: false
  },
  puestoId: {
    type: Number,
    required: true
  }
})

defineEmits(['slotClick', 'chipClick'])

const hover = ref(false)

const dayNames = ['DOM', 'LUN', 'MAR', 'MIE', 'JUE', 'VIE', 'SAB']

const formatDayHeader = (date) => {
  return `${dayNames[date.getDay()]}<br>${date.getDate()}`
}

const getDateKey = (date) => {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

const getAssignments = (day, slotId) => {
  const dayStr = getDateKey(day)
  //console.log('Buscando asignaciones para:', dayStr, slotId)
  //console.log('Schedules disponibles:', props.schedules)

  // Si no hay datos para ese día, retornar array vacío
  if (!props.schedules[dayStr]) {
    //console.log('No hay datos para el día:', dayStr)
    return []
  }

  // Retornar los usuarios asignados a ese turno específico
  const assignments = props.schedules[dayStr][slotId] || []
  //console.log('Asignaciones encontradas:', assignments)
  return assignments
}

const getColorUser = (userId) => {
  const user = props.users.find((u) => u.id === userId)
  return user?.color || '#CCCCCC'
}

function getMondayOfWeek(weekNumber, year) {
  console.log('getMondayOfWeek', weekNumber, year)
  // Asegurarnos de que weekNumber sea un número válido
  if (weekNumber < 1 || weekNumber > 53) {
    throw new Error('El número de semana debe estar entre 1 y 53.')
  }

  // Crear una fecha al inicio del año
  const firstDayOfYear = new Date(year, 0, 1)

  // Calcular el día de la semana del 1 de enero (0 = domingo, 1 = lunes, ..., 6 = sábado)
  const firstDayOfWeek = firstDayOfYear.getDay()

  // Encontrar el jueves de la primera semana del año
  const daysToFirstThursday = (11 - firstDayOfWeek) % 7 // Ajuste para alcanzar el jueves
  const firstThursday = new Date(year, 0, 1 + daysToFirstThursday)

  // Calcular el lunes de la semana 1 basado en el primer jueves
  const firstMonday = new Date(firstThursday)
  firstMonday.setDate(firstThursday.getDate() - 3) // Retroceder al lunes de esa semana

  // Calcular el lunes de la semana deseada
  const targetMonday = new Date(firstMonday)
  targetMonday.setDate(firstMonday.getDate() + (weekNumber - 1) * 7)

  return targetMonday
}

const days = computed(() => {
  if (props.weekOffset === undefined) return []

  try {
    const firstDay = getMondayOfWeek(props.weekOffset, props.selectedYear)
    const result = []

    // Mostrar solo 7 días (una semana) si readOnly es true, de lo contrario mostrar 42 días (6 semanas)
    const daysToShow = props.readOnly ? 7 : 42

    for (let i = 0; i < daysToShow; i++) {
      const day = new Date(firstDay)
      day.setDate(firstDay.getDate() + i)
      result.push(day)
    }

    return result
  } catch (error) {
    console.error('Error calculando días:', error)
    return []
  }
})

const weekHeaders = computed(() => {
  if (!days.value.length) return []

  const headers = []

  // Si readOnly es true, mostrar solo un encabezado de semana
  if (props.readOnly) {
    const weekStart = days.value[0]
    const weekNumber = getISOWeekNumber(weekStart)
    const month = months[weekStart.getMonth()]
    const year = weekStart.getFullYear()

    headers.push({
      weekNumber,
      month,
      year
    })
  } else {
    // Ahora mostrar 6 semanas
    for (let i = 0; i < 6; i++) {
      const weekStart = days.value[i * 7]
      if (!weekStart) continue // Protección contra undefined

      const weekNumber = getISOWeekNumber(weekStart)
      const month = months[weekStart.getMonth()]
      const year = weekStart.getFullYear()

      headers.push({
        weekNumber,
        month,
        year
      })
    }
  }

  return headers
})

// Mantenemos getISOWeekNumber para los headers
const getISOWeekNumber = (date) => {
  const target = new Date(date.valueOf())
  const dayNr = (date.getDay() + 6) % 7

  target.setDate(target.getDate() - dayNr + 3)

  const firstThursday = target.valueOf()
  target.setMonth(0, 1)

  if (target.getDay() !== 4) {
    target.setMonth(0, 1 + ((4 - target.getDay() + 7) % 7))
  }

  return 1 + Math.ceil((firstThursday - target) / 604800000)
}

// // Función para identificar si un slot es un turno tarde
// const isTurnoTarde = (slot) => {
//   return slot.name.toLowerCase().includes('tarde')
// }
</script>

<style scoped>
.timeline-container {
  position: relative;
  overflow-x: auto;
  margin: 0 -16px;
}

/* Estilo específico para vista de solo lectura (centrado) */
.centered-view {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  width: 100%;
}

.schedule-table {
  /* width: 1480px !important;
  min-width: 1480px; */
  border-collapse: collapse;
  table-layout: fixed;
  background: white;
  border: 2px solid #aaa;
}

/* Estilo específico para la tabla de una sola semana */
.single-week-table {
  width: 460px !important;
  min-width: 460px;
  margin: 0 auto;
}

.fixed-column {
  position: sticky;
  padding: 4px !important;
  width: 82px !important;
  font-size: 12px !important;
  text-align: center;
  left: 0;
  z-index: 1;
  border: 1px solid #e0e0e0;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);
}

.slots-header {
  width: fit-content;
  min-width: auto;
  padding: 6px 12px;
  white-space: nowrap;
}

.slots-column {
  padding: 4px 6px;
  white-space: nowrap;
}

.week-header {
  border: 1px solid #e0e0e0;
  border-right: 2px solid #e0e0e0;
  padding: 8px;
  font-weight: bold;
  white-space: nowrap;
}

.day-header {
  /* padding: 6px; */
  border: 1px solid #e0e0e0;
  font-size: 0.9rem;
  font-weight: bold;
  white-space: nowrap;
  width: 40px !important;
}

.time-slot {
  border: 1px solid #e0e0e0;
  /* padding: 4px; */
  vertical-align: top;
  width: 45px !important;
  height: auto !important;
  min-height: 30px;
}

.slot-content {
  min-height: unset;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: center;
  overflow-y: auto;
}

.cursor-pointer {
  cursor: pointer;
}

.border-primary {
  border: 2px solid rgb(var(--v-theme-primary));
}

.gap-1 {
  gap: 4px;
}

.text-center {
  text-align: center;
}

/* Ajustar el tamaño del chip */
:deep(.v-chip) {
  height: 20px !important;
  padding: 0 6px !important;
  width: 90%;
  justify-content: center;
  margin: 1px 0;
}

/* Asegurar que la tabla mantiene su estructura */
tbody tr {
  height: auto !important;
}

/* Estilo para el scrollbar */
.slot-content::-webkit-scrollbar {
  width: 4px;
}

.slot-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.slot-content::-webkit-scrollbar-thumb {
  background: #aaa;
  border-radius: 2px;
}

.slot-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Añadir borde especial solo para el borde derecho de los domingos */
.schedule-table tbody tr td:nth-child(7n + 1) {
  border-right: 2px solid #000000;
}

/* Estilo para la fila separadora */
.separator-row-1 {
  height: 1px !important;
  line-height: 1px !important;
  border: none !important;
  border-bottom-color: black !important;
}

.separator-cell-1 {
  padding: 0 !important;
  height: 1px !important;
  line-height: 1px !important;
  background-color: black !important;
  /* border: none !important; */
  display: table-cell !important;
}

.separator-row-3 {
  height: 2px !important;
  line-height: 2px !important;
  border: none !important;
}

.separator-cell-3 {
  padding: 0 !important;
  height: 2px !important;
  line-height: 2px !important;
  background-color: black !important;
  border: none !important;
  display: table-cell !important;
}
</style>
